import { useState, useEffect, useRef } from 'react';
import useAuth from './useAuth';
// API
import API from '../API';
const initialState = {
  page: 0,
  users: [],
  total_pages: 0,
  total_results: 0
};
export const useUserListFetch = () => {
  const auth = useAuth();
  const [userState, setUserState] = useState(initialState);
  const [userSearchValue,setUserSearchValue] = useState('');
  const [userIncludeInactive,setUserIncludeInactive] = useState(false)
  const [userTrigger, setUserTrigger] = useState(false);
  const [userLoading, setUserLoading] = useState(false);
  const [userError, setUserError] = useState(false);
  const accessToken = auth.auth.accessToken
  console.log("binne use fetch")
  
  console.log(userSearchValue)
  const fetchUserList = async(userSearchValue)=>{
    try {
      setUserLoading(true);
      setUserError(false);
     console.log("binne fetchUserslist")
      const data = await API.fetchUsers(userSearchValue,"",userIncludeInactive,"",accessToken)
     
      console.log(data.users)
      setUserState({  
       ...data
        
      }
      )

      setUserLoading(false)
      setUserTrigger(false)

    } catch (error) {
      console.log(error)
      setUserError(true);
    }
  }

  useEffect(()=>{
    console.log("useEffect is getrigger")
    setUserState(initialState)
    fetchUserList(userSearchValue)
  },[userSearchValue,userTrigger,userIncludeInactive]);

return{userState,userLoading,userError,setUserSearchValue,setUserIncludeInactive,setUserLoading,setUserTrigger};


};
